import React from 'react';
import createReactClass from 'create-react-class';
import Widget from '../common/Widget';
import debounce from '../../helpers/debounce';
import request from '../../helpers/request';
import purchaseSuggestionConfig from './config/purchaseSuggestionConfig';

var BudgetListWidget = createReactClass({
  getInitialState() {
    return {
      loaderMessage: 'Hole Haushaltsstellen',
      budgetLines: [],
      numberFilter: '',
      nameFilter: ''
    };
  },

  componentWillMount() {
    this.debouncedReloadData = debounce(this.reloadData, 300);
  },

  componentDidMount() {
    this.reloadData();
  },

  reloadData() {
    request.get({
      url: purchaseSuggestionConfig.budgetApiUrl,
      data: this.createFilterParams(),
      success: data => {
        if (this.isMounted()) {
          this.setState({
            budgetLines: data
          });
        }
      }
    });
  },

  createFilterParams() {
    return {
      numberFilter: this.state.numberFilter,
      nameFilter: this.state.nameFilter
    };
  },

  applyFilter(e) {
    var propName = e.target.name;
    var value = e.target.value;

    var newState = {};
    newState[propName] = value;

    this.setState(newState, () => this.debouncedReloadData());
  },

  render() {
    let budgetLines = this.state.budgetLines.map(x =>
      <tr>
        <td>{x.number}</td>
        <td>{x.name}</td>
        <td>€ {x.balance}</td>
      </tr>
    );

    return (
      <Widget title="Haushaltsstellen" icon="file-archive-o" containerClassName="col-sm-12 col-md-12 col-lg-6">
        <div className="budget-widget-body custom-scroll table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Nummer</th>
                <th>Bezeichnung</th>
                <th>Kreditrest</th>
              </tr>
              <tr>
                <th>
                  <input type="text" name="numberFilter" className="form-control" placeholder="Filter..." onChange={this.applyFilter} />
                </th>
                <th>
                  <input type="text" name="nameFilter" className="form-control" placeholder="Filter..." onChange={this.applyFilter} />
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {budgetLines}
            </tbody>
          </table>
        </div>
      </Widget>
    );
  }
});

export default BudgetListWidget;



// WEBPACK FOOTER //
// ./src/components/purchasesuggestions/BudgetListWidget.js